module.exports = __webpack_public_path__ + "static/media/AwsDoc2.9a0370e4.png";